var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ci-loading",class:[
		("ci-loading--" + _vm.state)
	]},[_c('ci-leaf',{staticClass:"ci-loading__leaf",attrs:{"theme":_vm.theme,"filled":false}}),_c('div',{staticClass:"ci-loading__progress"},[_c('ci-leaf',{staticClass:"ci-loading__leaf ci-loading__leaf--fill",attrs:{"theme":_vm.theme,"mask":_vm.animatedProgress}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }